export default {
  data() {
    return {
      loading: false,
      presentaciones: [],
      search: "",
      item: null,
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Dia de declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion"
        },

      ],
      data_fecha: {
        fecha_usuario: "",
        fecha: ""
      },
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
    };
  },



  async created() {
    await this.getListadoDeclaracionesInicial();
  },
  methods: {

    cargarDocumentos(item) {
      console.log("documentos");
      console.log(item);
    },


    async getListadoDeclaracionesInicial() {
      this.data_fecha.fecha_usuario = this.date.split("-")
        .reverse()
        .join("/");

      this.data_fecha.fecha = this.date;

      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.getListadoDeclaracionesInicial(this.data_fecha);
        console.log(r.data.data);

        
        if(r.data.data == 0){
          this.$toast.info(r.data.message);
          this.loading = false;
        }else{
        this.presentaciones = r.data.data;

          this.loading = false;

        }
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al obtener los del día"
        );
      }
    },
  },
};